import type { MenuRecipesState } from 'reducers/menu-recipes/recipes'

export const getRecipeIdByCoreIdMap = (state: MenuRecipesState) => state.recipesV3.coreIdToUUID
